// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3W_SW","buttons":"PendingPaymentAlert_buttons__3PmSJ"};